import { useCallback, useMemo, useState } from 'react';

import { exportToExcel } from './core';
import { ExportPreparerFactory } from './factory';

export const useExcelExport = (moduleName: string) => {
  const [isExporting, setIsExporting] = useState(false);
  const preparer = useMemo(
    () => ExportPreparerFactory.create(moduleName),
    [moduleName],
  );

  const exportData = useCallback(
    async (
      selectedItems: any[],
      filename: string,
      userId?: number,
      entityName?: string,
      interfaceName?: string,
      additionalData?: any,
    ) => {
      setIsExporting(true);
      try {
        const sheets = await preparer.prepareForExport(
          selectedItems,
          additionalData,
        );

        await exportToExcel({
          filename,
          sheets,
          userId,
          entityName,
          interfaceName,
        });
      } catch (error) {
        console.error('Erro na exportação:', error);
        throw error;
      } finally {
        setIsExporting(false);
      }
    },
    [preparer],
  );

  return { exportData, isExporting };
};
